// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"75d16e80","453":"99571545","518":"374c210c","594":"4a8e64a1"}[chunkId] + ".chunk.js";
};